import React from 'react';

import { SimpleCallback } from '../../../typings';
import { Button } from '../../button/button';
import { SimpleText } from '../../simple-text/simple-text';
import { TEACHER_QUIZ_MODE } from '../constants';

import './quiz__header-controls.scss';

interface Props {
    mode: TEACHER_QUIZ_MODE;
    onlineStudentsCount: number;
    handleMainButtonClick?: SimpleCallback;
    handleStatButtonClick?: SimpleCallback;
    isLastQuestion?: boolean;
    isStatButtonDisabled?: boolean;
}

const QuizHeaderControls = (props: Props) => {
    const { mode, handleMainButtonClick, handleStatButtonClick, isLastQuestion } = props;

    if (mode === TEACHER_QUIZ_MODE.START_SCREEN) {
        return null;
    }

    return (
        <div className="quiz-teacher__header-controls">
            {mode === TEACHER_QUIZ_MODE.QUESTION && (
                <div className="quiz-teacher__button-wrapper">
                    <Button onClick={handleStatButtonClick} rounded view={Button.VIEW.SECONDARY}>
                        <SimpleText id="quiz.action.showAnswers" />
                    </Button>
                </div>
            )}
            {mode !== TEACHER_QUIZ_MODE.FINAL_SCREEN && mode !== TEACHER_QUIZ_MODE.QUESTION && (
                <div className="quiz-teacher__button-wrapper">
                    <Button onClick={handleMainButtonClick} rounded view={Button.VIEW.ACTION}>
                        <SimpleText id={`quiz.action.${isLastQuestion ? 'end' : 'next'}`} />
                    </Button>
                </div>
            )}
        </div>
    );
};

export default QuizHeaderControls;
